import type { NotificationResponseDto } from '@trellis/api'
import {
  AlertTriangle,
  Bell,
  BellOff,
  BellRing,
  Clock,
  CreditCard,
  FileText,
  RefreshCw,
} from 'lucide-react'

export function getNotificationIcon(type: string) {
  switch (type) {
    case 'INVOICE_OVERDUE':
      return (
        <FileText className="text-destructive-text size-4 shrink-0" aria-hidden="true" />
      )
    case 'INVOICE_APPROACHING_DUE':
      return (
        <AlertTriangle className="size-4 shrink-0 text-amber-500" aria-hidden="true" />
      )
    case 'QUOTE_EXPIRING_SOON':
      return <Clock className="size-4 shrink-0 text-amber-500" aria-hidden="true" />
    case 'PAYMENT_RECEIVED':
      return <CreditCard className="size-4 shrink-0 text-green-600" aria-hidden="true" />
    case 'RECURRING_INVOICE_GENERATED':
      return <RefreshCw className="text-primary size-4 shrink-0" aria-hidden="true" />
    case 'REMINDER_APPROACHING_DUE':
      return <BellRing className="size-4 shrink-0 text-amber-500" aria-hidden="true" />
    case 'REMINDER_OVERDUE':
      return (
        <BellOff className="text-destructive-text size-4 shrink-0" aria-hidden="true" />
      )
    case 'INVOICE_ESCALATED':
      return <AlertTriangle className="size-4 shrink-0 text-red-700" aria-hidden="true" />
    default:
      return <Bell className="text-muted-foreground size-4 shrink-0" aria-hidden="true" />
  }
}

export function getNavigationPath(notification: NotificationResponseDto): string | null {
  if (notification.actionUrl?.startsWith('/')) return notification.actionUrl

  const metadata = notification.metadata
  if (!metadata) return null

  if (metadata.invoiceId) return `/invoices/${metadata.invoiceId}`
  if (metadata.quoteId) return `/quotes/${metadata.quoteId}`
  return null
}
